// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.4
//   protoc               v5.28.2
// source: stcs_dm.entity.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import {
  StcsAccDataSourceTypeEnum,
  stcsAccDataSourceTypeEnumFromJSON,
  stcsAccDataSourceTypeEnumToJSON,
} from "./stcs_enums.entity";

export const protobufPackage = "stcs_cmw";

export interface DmCompDataOverView {
  ref_id_org: string;
  data_coverage_percentage: number;
  comp_list: DmCompDataOverView_DmCompListItem[];
}

export interface DmCompDataOverView_DmCompListItem {
  ref_id_comp: string;
  comp_display_name: string;
  comp_acc_data_source?: StcsAccDataSourceTypeEnum | undefined;
  comp_acc_data_last_update?: string | undefined;
  comp_acc_data_data_range_begin?: string | undefined;
  comp_acc_data_data_range_end?: string | undefined;
  comp_acc_mapping_pnl_unmapped?: boolean | undefined;
  comp_acc_mapping_bs_unmapped?: boolean | undefined;
  comp_acc_mapping_is_draft?: boolean | undefined;
}

export interface DmOrgFsdPreview {
  ref_id_org: string;
  /** Total number of level 2 accounts removed from the FSD */
  removed_level_2_total_count: number;
  /** Number of level 2 accounts removed from the FSD in PNL */
  removed_level_2_pnl_count: number;
  /** Number of level 2 accounts removed from the FSD in BS */
  removed_level_2_bs_count: number;
  /** List of companies with their FSD preview details */
  comp_list: DmOrgFsdPreview_DmFsdPreviewCompListItem[];
}

export interface DmOrgFsdPreview_DmFsdPreviewCompListItem {
  ref_id_comp: string;
  comp_display_name: string;
  acm_pnl_unmapped_count: number;
  acm_bs_unmapped_count: number;
}

function createBaseDmCompDataOverView(): DmCompDataOverView {
  return { ref_id_org: "", data_coverage_percentage: 0, comp_list: [] };
}

export const DmCompDataOverView: MessageFns<DmCompDataOverView> = {
  encode(message: DmCompDataOverView, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_org !== "") {
      writer.uint32(10).string(message.ref_id_org);
    }
    if (message.data_coverage_percentage !== 0) {
      writer.uint32(17).double(message.data_coverage_percentage);
    }
    for (const v of message.comp_list) {
      DmCompDataOverView_DmCompListItem.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DmCompDataOverView {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDmCompDataOverView();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.data_coverage_percentage = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.comp_list.push(DmCompDataOverView_DmCompListItem.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DmCompDataOverView {
    return {
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      data_coverage_percentage: isSet(object.data_coverage_percentage)
        ? globalThis.Number(object.data_coverage_percentage)
        : 0,
      comp_list: globalThis.Array.isArray(object?.comp_list)
        ? object.comp_list.map((e: any) => DmCompDataOverView_DmCompListItem.fromJSON(e))
        : [],
    };
  },

  toJSON(message: DmCompDataOverView): unknown {
    const obj: any = {};
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.data_coverage_percentage !== 0) {
      obj.data_coverage_percentage = message.data_coverage_percentage;
    }
    if (message.comp_list?.length) {
      obj.comp_list = message.comp_list.map((e) => DmCompDataOverView_DmCompListItem.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DmCompDataOverView>, I>>(base?: I): DmCompDataOverView {
    return DmCompDataOverView.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DmCompDataOverView>, I>>(object: I): DmCompDataOverView {
    const message = createBaseDmCompDataOverView();
    message.ref_id_org = object.ref_id_org ?? "";
    message.data_coverage_percentage = object.data_coverage_percentage ?? 0;
    message.comp_list = object.comp_list?.map((e) => DmCompDataOverView_DmCompListItem.fromPartial(e)) || [];
    return message;
  },
};

function createBaseDmCompDataOverView_DmCompListItem(): DmCompDataOverView_DmCompListItem {
  return {
    ref_id_comp: "",
    comp_display_name: "",
    comp_acc_data_source: undefined,
    comp_acc_data_last_update: undefined,
    comp_acc_data_data_range_begin: undefined,
    comp_acc_data_data_range_end: undefined,
    comp_acc_mapping_pnl_unmapped: undefined,
    comp_acc_mapping_bs_unmapped: undefined,
    comp_acc_mapping_is_draft: undefined,
  };
}

export const DmCompDataOverView_DmCompListItem: MessageFns<DmCompDataOverView_DmCompListItem> = {
  encode(message: DmCompDataOverView_DmCompListItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_comp !== "") {
      writer.uint32(10).string(message.ref_id_comp);
    }
    if (message.comp_display_name !== "") {
      writer.uint32(18).string(message.comp_display_name);
    }
    if (message.comp_acc_data_source !== undefined) {
      writer.uint32(24).int32(message.comp_acc_data_source);
    }
    if (message.comp_acc_data_last_update !== undefined) {
      writer.uint32(34).string(message.comp_acc_data_last_update);
    }
    if (message.comp_acc_data_data_range_begin !== undefined) {
      writer.uint32(42).string(message.comp_acc_data_data_range_begin);
    }
    if (message.comp_acc_data_data_range_end !== undefined) {
      writer.uint32(50).string(message.comp_acc_data_data_range_end);
    }
    if (message.comp_acc_mapping_pnl_unmapped !== undefined) {
      writer.uint32(56).bool(message.comp_acc_mapping_pnl_unmapped);
    }
    if (message.comp_acc_mapping_bs_unmapped !== undefined) {
      writer.uint32(64).bool(message.comp_acc_mapping_bs_unmapped);
    }
    if (message.comp_acc_mapping_is_draft !== undefined) {
      writer.uint32(72).bool(message.comp_acc_mapping_is_draft);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DmCompDataOverView_DmCompListItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDmCompDataOverView_DmCompListItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.comp_display_name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.comp_acc_data_source = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.comp_acc_data_last_update = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.comp_acc_data_data_range_begin = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.comp_acc_data_data_range_end = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.comp_acc_mapping_pnl_unmapped = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.comp_acc_mapping_bs_unmapped = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.comp_acc_mapping_is_draft = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DmCompDataOverView_DmCompListItem {
    return {
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
      comp_display_name: isSet(object.comp_display_name) ? globalThis.String(object.comp_display_name) : "",
      comp_acc_data_source: isSet(object.comp_acc_data_source)
        ? stcsAccDataSourceTypeEnumFromJSON(object.comp_acc_data_source)
        : undefined,
      comp_acc_data_last_update: isSet(object.comp_acc_data_last_update)
        ? globalThis.String(object.comp_acc_data_last_update)
        : undefined,
      comp_acc_data_data_range_begin: isSet(object.comp_acc_data_data_range_begin)
        ? globalThis.String(object.comp_acc_data_data_range_begin)
        : undefined,
      comp_acc_data_data_range_end: isSet(object.comp_acc_data_data_range_end)
        ? globalThis.String(object.comp_acc_data_data_range_end)
        : undefined,
      comp_acc_mapping_pnl_unmapped: isSet(object.comp_acc_mapping_pnl_unmapped)
        ? globalThis.Boolean(object.comp_acc_mapping_pnl_unmapped)
        : undefined,
      comp_acc_mapping_bs_unmapped: isSet(object.comp_acc_mapping_bs_unmapped)
        ? globalThis.Boolean(object.comp_acc_mapping_bs_unmapped)
        : undefined,
      comp_acc_mapping_is_draft: isSet(object.comp_acc_mapping_is_draft)
        ? globalThis.Boolean(object.comp_acc_mapping_is_draft)
        : undefined,
    };
  },

  toJSON(message: DmCompDataOverView_DmCompListItem): unknown {
    const obj: any = {};
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    if (message.comp_display_name !== "") {
      obj.comp_display_name = message.comp_display_name;
    }
    if (message.comp_acc_data_source !== undefined) {
      obj.comp_acc_data_source = stcsAccDataSourceTypeEnumToJSON(message.comp_acc_data_source);
    }
    if (message.comp_acc_data_last_update !== undefined) {
      obj.comp_acc_data_last_update = message.comp_acc_data_last_update;
    }
    if (message.comp_acc_data_data_range_begin !== undefined) {
      obj.comp_acc_data_data_range_begin = message.comp_acc_data_data_range_begin;
    }
    if (message.comp_acc_data_data_range_end !== undefined) {
      obj.comp_acc_data_data_range_end = message.comp_acc_data_data_range_end;
    }
    if (message.comp_acc_mapping_pnl_unmapped !== undefined) {
      obj.comp_acc_mapping_pnl_unmapped = message.comp_acc_mapping_pnl_unmapped;
    }
    if (message.comp_acc_mapping_bs_unmapped !== undefined) {
      obj.comp_acc_mapping_bs_unmapped = message.comp_acc_mapping_bs_unmapped;
    }
    if (message.comp_acc_mapping_is_draft !== undefined) {
      obj.comp_acc_mapping_is_draft = message.comp_acc_mapping_is_draft;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DmCompDataOverView_DmCompListItem>, I>>(
    base?: I,
  ): DmCompDataOverView_DmCompListItem {
    return DmCompDataOverView_DmCompListItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DmCompDataOverView_DmCompListItem>, I>>(
    object: I,
  ): DmCompDataOverView_DmCompListItem {
    const message = createBaseDmCompDataOverView_DmCompListItem();
    message.ref_id_comp = object.ref_id_comp ?? "";
    message.comp_display_name = object.comp_display_name ?? "";
    message.comp_acc_data_source = object.comp_acc_data_source ?? undefined;
    message.comp_acc_data_last_update = object.comp_acc_data_last_update ?? undefined;
    message.comp_acc_data_data_range_begin = object.comp_acc_data_data_range_begin ?? undefined;
    message.comp_acc_data_data_range_end = object.comp_acc_data_data_range_end ?? undefined;
    message.comp_acc_mapping_pnl_unmapped = object.comp_acc_mapping_pnl_unmapped ?? undefined;
    message.comp_acc_mapping_bs_unmapped = object.comp_acc_mapping_bs_unmapped ?? undefined;
    message.comp_acc_mapping_is_draft = object.comp_acc_mapping_is_draft ?? undefined;
    return message;
  },
};

function createBaseDmOrgFsdPreview(): DmOrgFsdPreview {
  return {
    ref_id_org: "",
    removed_level_2_total_count: 0,
    removed_level_2_pnl_count: 0,
    removed_level_2_bs_count: 0,
    comp_list: [],
  };
}

export const DmOrgFsdPreview: MessageFns<DmOrgFsdPreview> = {
  encode(message: DmOrgFsdPreview, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_org !== "") {
      writer.uint32(10).string(message.ref_id_org);
    }
    if (message.removed_level_2_total_count !== 0) {
      writer.uint32(16).int32(message.removed_level_2_total_count);
    }
    if (message.removed_level_2_pnl_count !== 0) {
      writer.uint32(24).int32(message.removed_level_2_pnl_count);
    }
    if (message.removed_level_2_bs_count !== 0) {
      writer.uint32(32).int32(message.removed_level_2_bs_count);
    }
    for (const v of message.comp_list) {
      DmOrgFsdPreview_DmFsdPreviewCompListItem.encode(v!, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DmOrgFsdPreview {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDmOrgFsdPreview();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.removed_level_2_total_count = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.removed_level_2_pnl_count = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.removed_level_2_bs_count = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.comp_list.push(DmOrgFsdPreview_DmFsdPreviewCompListItem.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DmOrgFsdPreview {
    return {
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      removed_level_2_total_count: isSet(object.removed_level_2_total_count)
        ? globalThis.Number(object.removed_level_2_total_count)
        : 0,
      removed_level_2_pnl_count: isSet(object.removed_level_2_pnl_count)
        ? globalThis.Number(object.removed_level_2_pnl_count)
        : 0,
      removed_level_2_bs_count: isSet(object.removed_level_2_bs_count)
        ? globalThis.Number(object.removed_level_2_bs_count)
        : 0,
      comp_list: globalThis.Array.isArray(object?.comp_list)
        ? object.comp_list.map((e: any) => DmOrgFsdPreview_DmFsdPreviewCompListItem.fromJSON(e))
        : [],
    };
  },

  toJSON(message: DmOrgFsdPreview): unknown {
    const obj: any = {};
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.removed_level_2_total_count !== 0) {
      obj.removed_level_2_total_count = Math.round(message.removed_level_2_total_count);
    }
    if (message.removed_level_2_pnl_count !== 0) {
      obj.removed_level_2_pnl_count = Math.round(message.removed_level_2_pnl_count);
    }
    if (message.removed_level_2_bs_count !== 0) {
      obj.removed_level_2_bs_count = Math.round(message.removed_level_2_bs_count);
    }
    if (message.comp_list?.length) {
      obj.comp_list = message.comp_list.map((e) => DmOrgFsdPreview_DmFsdPreviewCompListItem.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DmOrgFsdPreview>, I>>(base?: I): DmOrgFsdPreview {
    return DmOrgFsdPreview.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DmOrgFsdPreview>, I>>(object: I): DmOrgFsdPreview {
    const message = createBaseDmOrgFsdPreview();
    message.ref_id_org = object.ref_id_org ?? "";
    message.removed_level_2_total_count = object.removed_level_2_total_count ?? 0;
    message.removed_level_2_pnl_count = object.removed_level_2_pnl_count ?? 0;
    message.removed_level_2_bs_count = object.removed_level_2_bs_count ?? 0;
    message.comp_list = object.comp_list?.map((e) => DmOrgFsdPreview_DmFsdPreviewCompListItem.fromPartial(e)) || [];
    return message;
  },
};

function createBaseDmOrgFsdPreview_DmFsdPreviewCompListItem(): DmOrgFsdPreview_DmFsdPreviewCompListItem {
  return { ref_id_comp: "", comp_display_name: "", acm_pnl_unmapped_count: 0, acm_bs_unmapped_count: 0 };
}

export const DmOrgFsdPreview_DmFsdPreviewCompListItem: MessageFns<DmOrgFsdPreview_DmFsdPreviewCompListItem> = {
  encode(message: DmOrgFsdPreview_DmFsdPreviewCompListItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_comp !== "") {
      writer.uint32(10).string(message.ref_id_comp);
    }
    if (message.comp_display_name !== "") {
      writer.uint32(18).string(message.comp_display_name);
    }
    if (message.acm_pnl_unmapped_count !== 0) {
      writer.uint32(24).int32(message.acm_pnl_unmapped_count);
    }
    if (message.acm_bs_unmapped_count !== 0) {
      writer.uint32(32).int32(message.acm_bs_unmapped_count);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DmOrgFsdPreview_DmFsdPreviewCompListItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDmOrgFsdPreview_DmFsdPreviewCompListItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.comp_display_name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.acm_pnl_unmapped_count = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.acm_bs_unmapped_count = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DmOrgFsdPreview_DmFsdPreviewCompListItem {
    return {
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
      comp_display_name: isSet(object.comp_display_name) ? globalThis.String(object.comp_display_name) : "",
      acm_pnl_unmapped_count: isSet(object.acm_pnl_unmapped_count)
        ? globalThis.Number(object.acm_pnl_unmapped_count)
        : 0,
      acm_bs_unmapped_count: isSet(object.acm_bs_unmapped_count) ? globalThis.Number(object.acm_bs_unmapped_count) : 0,
    };
  },

  toJSON(message: DmOrgFsdPreview_DmFsdPreviewCompListItem): unknown {
    const obj: any = {};
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    if (message.comp_display_name !== "") {
      obj.comp_display_name = message.comp_display_name;
    }
    if (message.acm_pnl_unmapped_count !== 0) {
      obj.acm_pnl_unmapped_count = Math.round(message.acm_pnl_unmapped_count);
    }
    if (message.acm_bs_unmapped_count !== 0) {
      obj.acm_bs_unmapped_count = Math.round(message.acm_bs_unmapped_count);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DmOrgFsdPreview_DmFsdPreviewCompListItem>, I>>(
    base?: I,
  ): DmOrgFsdPreview_DmFsdPreviewCompListItem {
    return DmOrgFsdPreview_DmFsdPreviewCompListItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DmOrgFsdPreview_DmFsdPreviewCompListItem>, I>>(
    object: I,
  ): DmOrgFsdPreview_DmFsdPreviewCompListItem {
    const message = createBaseDmOrgFsdPreview_DmFsdPreviewCompListItem();
    message.ref_id_comp = object.ref_id_comp ?? "";
    message.comp_display_name = object.comp_display_name ?? "";
    message.acm_pnl_unmapped_count = object.acm_pnl_unmapped_count ?? 0;
    message.acm_bs_unmapped_count = object.acm_bs_unmapped_count ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
